<template>
	<div class="m_container" :style="openType == 'mob' ? 'background:#fff' : ''"
		:class="openType != 'mob' ? 'flex_center flex_items vh100' : ''">
		<div class="content plr20 page_bg" style="box-sizing: border-box;"
			:class="openType != 'mob' ? 'container_w_h' : 'vh100 w100'"
			:style="openType == 'mob' ? 'padding-top:80px' : 'padding-top:'+pcPt+'px'">
			<div class="top page_bg flex_items flex flex_center" id="top" :class="openType != 'mob' ? 'ser-top' : ''">
				<div class="txt_center" :class="handleClick == 0 ? 'main_bg cf' : ''" @click="clickFn(0)">待审批</div>
				<div class="txt_center ml20" :class="handleClick == 1 ? 'main_bg cf' : ''" @click="clickFn(1)">已审批</div>
			</div>
			<div class="">
				<div class="b_r_10 flex plr20 mb20 pt20 pb20 bgfff" style="align-items: flex-start;"
					v-for="(item, index) in list" :key="index">
					<div class="flex1">
						<div class="flex flex_items flex_between mb20">
							<div class="flex flex_items">
								<div class="ca6 name">请假人</div>
								<div>{{item.user.name}}</div>
							</div>
							<div class="">
								<div @click="submit(item)" class="plr20 b_r_10 main_bg cf" style="padding: 5px 20px;" v-if="handleClick ==0">批准</div>
								<div class="main_color" v-else>已批准</div>
							</div>
						</div>
						<div class="flex flex_items mb20">
							<div class="ca6 name">请假日期</div>
							<div>{{item.date}}{{item.time == 'forenoon' ? '上午' : item.time == 'afternoon' ? '下午' : ''}}</div>
						</div>
						<div class="flex" style="align-items: flex-start;">
							<div class="ca6 name">请假事由</div>
							<div class="flex1">{{item.remark}}</div>
						</div>
					</div>
					
				</div>
				<div class="empty" v-if="list.length == 0">
					暂无数据
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		openType,
		pcContentHeight
	} from '@/utils/tool.js'
	import {
		Dialog
	} from "vant";
	export default ({
		data() {
			return {
				handleClick: 0,
				list: [],
				openType: openType(),
				id: '',
				pcPt: 120
			}
		},
		methods: {
			clickFn(t) {
				this.handleClick = t;
				this.list = []
				this.getList(t == 0 ? 'wait' : 'checked')
			},
			getList(t) {
				// 空或all：全部；wait：待审批；checked：已审批
				this.api
					.leaveList({
						status: t
					}, this.id)
					.then((res) => {
						this.list = res.data
					});
			},
			submit(item){
				Dialog.confirm({
						title: '审批',
						message: '是否批准当前申请？',
					})
					.then(() => {
						this.api.leaveConfirm({},item.id).then(res => {
							this.Toast('操作成功')
							this.getList('wait')
						}).catch(() => {

						})
					})
					.catch(() => {


					});
			},
		},
		created() {
			this.openType = openType()
			this.id = this.$route.query.id;
			this.getList('wait')
			if (this.openType != 'mob') {
				this.$nextTick(() => {
					this.pcPt = pcContentHeight('top');
				})
			}
		}
	})
</script>

<style scoped="scoped">
	.top {
		height: 80px;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		box-sizing: border-box;
		z-index: 2;
	}

	.ser-top.top {
		left: 50%;
		width: 390px;
		transform: translateX(-50%);
	}

	.top>div {
		width: 85px;
		height: 40px;
		line-height: 40px;
		border-radius: 10px;
	}

	.content {
		/* padding-top: 80px; */
		overflow-y: auto;
	}

	.name {
		width: 100px;
	}
</style>
